<template>
  <div>
    <Top></Top>
    <!-- 上传文件  -->
    <div class="file">
      <el-upload class="upload-demo" action=" https://www.rakumart-2c.com:8080/api/upload/uploadFile"
        :on-success="handleAvatarSuccess" :data="{ token: token }" :show-file-list="false">
        <el-button size="small" type="primary">納品書添付</el-button>
      </el-upload>
      <div class="name" v-if="delivery_file" :title="delivery_file">
        <a :href="delivery_file" target="_blank">
          <i class="el-icon-folder-checked"></i>

          <span>納品書</span>
        </a>
      </div>
    </div>
    <!-- 预览 -->
    <div class="w main" v-if="$route.query.ordno == undefined">
      <!-- 头部 -->
      <div class="head">
        <div class="logo">
          <router-link to="/">
            www.rakumart-2c.com
          </router-link>
        </div>
        <p>
          <span class="fl">注文NO:{{ orderID }}</span>

          <span class="fr">{{ time }}</span>
        </p>
      </div>
      <div class="content">
        <ol class="title">
          <li>選択</li>
          <li>NO</li>
          <li class="">写真</li>
          <li class="flex3">商品詳細</li>
          <li class="flex2">数量</li>
          <li class="flex2">単価（元）</li>
          <li class="flex2">小計</li>
          <!-- <li class="flex6">オプション</li> -->
          <!-- <li class="flex4">FBA（FNSKU）</li> -->
          <li class="flex4">備考欄</li>
          <li>削除</li>
        </ol>
        <ul class="details" v-for="(item, index) in newList" :key="index">
          <li>
            <input type="checkbox" v-model="item.checked" size="medium" @change="commoditySelect" style="margin: 0" />
          </li>
          <li>{{ index + 1 }}</li>
          <li class="">
            <div class="img">
              <router-link :to="item.type == 'rakumart'
                ? 'details?id=' + item.iid
                : `details1688?iid=${item.iid}&type=${item.type}${item.mi_id ? '&mi_id=' + item.mi_id : ''}`
                " target="_blank">
                <el-popover placement="right" width="400" trigger="hover">
                  <img :src="item.pic" alt style="width: 400px" />
                  <img :src="item.pic" alt slot="reference" />
                </el-popover>
              </router-link>
            </div>
          </li>
          <li class="flex3">
            <div>
              <p>
                カラー:
                <span>{{ item.color }}</span>
              </p>
              <p>
                サイズ:
                <span>{{ item.psize }}</span>
              </p>
            </div>
          </li>
          <li class="flex2">
            <input type="text" v-model="item.num" @change="changeNewNum(item.num, index)" />
          </li>
          <li class="flex2" v-if="item.priceRanges == null">
            {{ item.price }}
          </li>
          <li class="flex2" v-else id="pcice-li">
            <div v-if="$route.query.state == 1" style="line-height: 70px">
              {{ item.price }}
            </div>

            <div v-else>
              <div v-for="(item1, index1) in item.priceRanges" :key="index1" style="line-height: 23px">
                >={{ item1.begin }}￥{{ item1.price }}（元）
              </div>
            </div>
          </li>
          <li class="flex2" v-if="item.priceRanges == null">
            {{ item.price * item.num }}
          </li>
          <li class="flex2" v-else>
            <div v-if="$route.query.state == 1">
              {{ item.price * item.num }}
            </div>
            <div v-else>
              <!-- 1 -->
              <div v-if="item.priceRanges.length == 1">
                {{ item.priceRanges[0].price * item.num }}
              </div>
              <!-- 2 -->
              <div v-else-if="item.priceRanges.length == 2">
                <span v-if="item.num >= item.priceRanges[0].begin &&
                  item.priceRanges[1].begin > item.num
                ">{{ item.priceRanges[0].price * item.num }}</span>
                <span v-else-if="item.priceRanges[1].begin <= item.num">{{
                  item.priceRanges[1].price * item.num
                }}</span>
              </div>
              <!-- 3 -->
              <div v-else-if="item.priceRanges.length == 3">
                <span v-if="item.num >= item.priceRanges[0].begin &&
                  item.priceRanges[1].begin > item.num
                ">{{ item.priceRanges[0].price * item.num }}</span>
                <span v-else-if="item.priceRanges[1].begin <= item.num &&
                  item.priceRanges[2].begin > item.num
                ">{{ item.priceRanges[1].price * item.num }}</span>
                <span v-else-if="item.priceRanges[2].begin <= item.num">{{
                  item.priceRanges[2].price * item.num
                }}</span>
              </div>
            </div>
          </li>
          <!-- 点击显示option -->
          <!-- <li class="flex6">
          
            <div @click="options(index, item)">
              <p class="duoxuan">
                {{ sendOrderList.goods[index].poption }}
                <img src="../../assets/img/triangle2.png" class="tubiao" alt />
              </p>
            </div>
            <div class="option" v-show="item.checked_2">
              <div class="zhe"></div>
              <ul class="option-list">
                <li
                  :class="{ choose: isChoose }"
                  v-for="(item1, index1) in optionList[index]"
                  :key="index1"
                >
                  <input
                    type="checkbox"
                    v-model="item1.checked"
                    @change="optionsMoney"
                    class="checkbox"
                  />
                  <span>{{ item1.title }}</span>
                  <input
                    type="text"
                    v-model="item1.num"
                    :disabled="item1.disabled"
                    @change="optionsItem(index, item1.num, index1)"
                  />
                </li>
              </ul>
            </div>
          </li> -->
          <!-- <li class="flex4">
            <input
              type="text"
              v-model="sendOrderList.goods[index].fba"
              style="width: 150px"
            />
          </li> -->
          <li class="flex4">
            <textarea name="reworkmes" cols="20" rows="3" v-model="item.beikao" @focus="i = index"
              v-if="i != index"></textarea>
            <transition name="slide-fade">
              <textarea v-if="i == index" name="reworkmes" autofocus cols="29" rows="7" v-model="item.beikao"
                @blur="modify(2, index, item.beikao)" v-focus></textarea>
            </transition>
          </li>
          <li>
            <button @click="itemDel(index)" class="itemDel">削除</button>
          </li>
        </ul>
      </div>
      <div class="checkall">
        <div class="quanxuan">
          <div class="number">
            <p>商品数：{{ numTotal }}</p>
          </div>

          <input type="checkbox" v-model="checked1" size="medium" @change="commodityAll" />
          全てを選択
          <!-- <span @click="delOrder" v-if="shanchuShow">削除</span> -->
          <a href="javascript:;" class="zhuijia">
            追加
            <div class="tianjia">
              <a href="javascript:;" @click="getCartList">買い物かごから</a>
              <a href="javascript:;" style="border-top: 2px solid #eee" @click="addSPK">URL商品追加</a>
            </div>
          </a>
        </div>
        <!-- 数量 -->

        <div>
          <!-- 合计 -->
          <div class="heji">
            <p>
              合計金額:
              <strong>{{ (money + brokerage + optionCost).toFixed(2) }}</strong>
              元
              <span>({{ Math.round(Rate * (money + brokerage + optionCost)) }}
                円)
              </span>
            </p>
            <p class="rate">（1元={{ Rate }} 円）</p>
          </div>
          <a href="javascript:;" class="tichu" @click="verifySite(1)">注文を提出</a>
          <a href="javascript:;" class="save" @click="verifySite(0)">一時保存</a>
        </div>
      </div>
      <!-- 最终决定 -->
      <div class="finally">
        <div class="item">
          <h3>小計：</h3>
          <ul class="cost">
            <li>
              <span>商品金額：</span>
              {{ money.toFixed(2) }}元
            </li>
            <li>
              <span>手数料(15元/点)：</span>
              {{ brokerage.toFixed(2) }}元
            </li>
            <!-- <li>
            <span>オプション手数料：</span>
            {{ optionCost.toFixed(2) }}元
          </li> -->
            <!-- <li>
            <span>その他：</span>
            {{}}元
          </li> -->
          </ul>
        </div>
        <!-- 輸入者(Importer) -->
        <div class="item site">
          <h3>輸入者(Importer)</h3>
          <div class="importer">
            <el-select v-model="address1.remark" placeholder="配送先管理から選択" @change="selectSite($event, 1)" size="medium">
              <el-option v-for="item in aid" :key="item.aid" :label="item.remark" :value="item.aid"></el-option>
            </el-select>

            <div class="importer-box">
              <ul>
                <li>
                  <span>会社：</span>

                  <input type="text" v-model="address1.company" />
                </li>
                <li>
                  <span> 氏名：</span>

                  <input type="text" v-model="address1.realname" @blur="address1.company || verifySiteNull(address1.realname, 0)" />
                </li>
                <li>
                  <span> 郵便：</span>

                  <input type="text" v-model="address1.zip" @blur="verifySiteNull(address1.zip, 1)" />
                </li>
                <li>
                  <span> 住所：</span>

                  <input type="text" v-model="address1.address" @blur="verifySiteNull(address1.address, 2)" />
                </li>
                <li>
                  <span> 携帯番号：</span>

                  <input type="text" v-model="address1.mobile" @blur="verifySiteNull(address1.mobile, 3)" />
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- <a href="javascript:;">詳細</a> -->
        <!-- 配送先 -->
        <div class="site item">
          <h3>配送先</h3>

          <div class="importer">
            <el-select v-model="address2.remark" placeholder=" 配送先管理から選択" @change="selectSite($event, 2)" size="medium">
              <el-option v-for="item in hid" :key="item.aid" :label="item.remark" :value="item.aid"></el-option>
            </el-select>

            <div class="importer-box">
              <ul>
                <li>
                  <span> 会社：</span>

                  <input type="text" v-model="address2.company" />
                </li>
                <li>
                  <span> 氏名：</span>

                  <input type="text" v-model="address2.realname" @blur="verifySiteNull(address2.realname, 0)" />
                </li>
                <li>
                  <span> 郵便：</span>

                  <input type="text" v-model="address2.zip" @blur="verifySiteNull(address2.zip, 1)" />
                </li>
                <li>
                  <span> 住所：</span>

                  <input type="text" v-model="address2.address" @blur="verifySiteNull(address2.address, 2)" />
                </li>
                <li>
                  <span> 携帯番号：</span>

                  <input type="text" v-model="address2.mobile" @blur="verifySiteNull(address2.mobile, 3)" />
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="beizhu item">
          <h3>国際運送会社：</h3>
          <div class="top">
            <div class="logistics">

              <el-select v-model="sendOrderList.express" placeholder="请选择" size="medium"
                @change="changeExpress($event)">
                <el-option v-for="item in option" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <!-- <p
                v-if="
                  sendOrderList.express == '1' || sendOrderList.express == 'OCS'
                "
              >
                一箱３０KG以内、電池、水は含んだ商品は発送できません。
              </p>
              <p
                v-if="
                  sendOrderList.express == '2' ||
                  sendOrderList.express == '倉庫止め'
                "
              >
                一番安定した航空便。
              </p> -->
              <p v-if="sendOrderList.express == '3'
              ">
                5KG以下の時のみ使用可能。
              </p>
            </div>
          </div>
          <textarea name="reworkmes" cols="40" rows="8" v-model="sendOrderList.remark"></textarea>
        </div>
      </div>
    </div>
    <!-- 支付/修改 -->
    <div class="w main" v-else>
      <!-- 头部 -->
      <div class="head">
        <div class="logo">
          <router-link to="/">
            www.rakumart-2c.com
          </router-link>
        </div>
        <p>
          <span class="fl">注文NO:{{ orderID }}</span>
          <span class="fl" style="margin-left: 20px;color: #f3c622;">{{ ordno.shopify_name }}</span>
          <span class="fr">{{ time }}</span>
        </p>
      </div>
      <!-- 商品详情 -->
      <div class="content">
        <ol class="title">
          <li>選択</li>
          <li>NO</li>
          <li class="flex2">写真</li>
          <li class="flex4">商品詳細</li>
          <li class="flex2">発注数</li>
          <li class="flex2">在庫数</li>
          <li class="flex2" v-if="kno > 4">落札数</li>
          <li class="flex2" v-if="kno > 4">到着数</li>
          <li class="flex2">単価(元)</li>
          <li class="flex2">小計</li>
          <li class="flex2">国内送料</li>
          <!-- <li class="flex6">オプション</li> -->
          <!-- <li class="flex4">FBA（FNSKU）</li> -->
          <li class="flex4">備考欄</li>
          <li class="flex2" v-show="kno > 1">状態</li>
          <li v-show="flag">削除</li>
        </ol>
        <ul class="details" v-for="(item, index) in newList" :key="index">
          <li class="check">
            <input type="checkbox" v-model="item.checked" @change="commoditySelect" :disabled="!flag && kno < 9"
              style="margin: 0; width: 20px" />
            <span v-if="item.is_append_urgent == 1">換</span>
          </li>
          <!-- <li v-if="kno == 10">
            <input
              type="checkbox"
              v-model="item.checked"
              size="medium"
              @change="commoditySelect"
              style="margin: 0"
            />
          </li> -->
          <li>{{ index + 1 }}</li>
          <li class="flex2">
            <div class="img">
              <router-link :to="item.type == 'rakumart'
                ? 'details?id=' + item.iid
                : `details1688?iid=${item.iid}&type=${item.type}${item.mi_id ? '&mi_id=' + item.mi_id : ''}`
                " target="_blank">
                <el-popover placement="right" width="400" trigger="hover">
                  <img :src="item.pic" alt style="width: 400px" />
                  <img :src="item.pic" alt slot="reference" />
                </el-popover>
              </router-link>
            </div>
          </li>
          <li class="flex4">
            <div>
              <p>
                カラー:
                <span>{{ item.color }}</span>
              </p>
              <p>
                サイズ:
                <span>{{ item.psize }}</span>
              </p>
            </div>
          </li>
          <li class="flex2">
            <span v-if="!flag">{{ item.num }}</span>
            <input type="text" v-model="item.num" @change="changeNewNum(item.num, index)" v-else />
          </li>
          <li class="flex2">{{ item.zaiko }}</li>
          <li class="flex2" v-if="kno > 4">
            {{ item.rakusatu ? item.rakusatu : "0" }}
          </li>
          <li class="flex2" v-if="kno > 4">
            {{ item.tocyku ? item.tocyku : "0" }}
          </li>
          <li class="flex2">{{ item.price }}</li>
          <li class="flex2">
            {{
              item.zaiko
                ? (item.price * item.zaiko).toFixed(2)
                : (item.price * item.num).toFixed(2)
            }}
          </li>
          <li class="flex2">{{ item.gnsong ? item.gnsong : "0" }}</li>
          <!-- <li class="flex6" v-if="$route.query.cid != undefined">
            <span class="span">{{ item.poption }}</span>
          </li> -->
          <!-- 点击显示option -->
          <!-- <li class="flex6" v-else>
           
            <div @click="options(index, item)">
              <p class="duoxuan">
                {{ sendOrderList.goods[index].poption }}
                <img src="../../assets/img/triangle2.png" class="tubiao" alt />
              </p>
            </div>

          
            <div class="option" v-show="item.checked_2">
              <div class="zhe"></div>
              <ul class="option-list">
                <li
                  :class="{ choose: isChoose }"
                  v-for="(item1, index1) in optionList[index]"
                  :key="index1"
                >
                  <input
                    type="checkbox"
                    v-model="item1.checked"
                    @change="optionsMoney"
                    class="checkbox"
                  />
                  <span>{{ item1.title }}</span>
                  <input
                    type="text"
                    v-model="item1.num"
                    :disabled="item1.disabled"
                    @change="optionsItem(index, item1.num, index1)"
                  />
                </li>
              </ul>
            </div>
          </li> -->
          <!-- <li class="flex4">
            <input
              type="text"
              v-model="item.fba"
              style="width: 130px"
              @blur="modify(1, index, item.fba)"
            />
          </li> -->
          <li class="flex4">
            <textarea name="reworkmes" cols="20" rows="3" v-model="item.bei" @focus="i = index" style="resize: none"
              v-if="i != index"></textarea>
            <transition name="slide-fade">
              <textarea v-if="i == index" name="reworkmes" cols="29" rows="7" v-model="item.bei"
                @blur="modify(2, index, item.bei)" style="resize: none" v-focus></textarea>
            </transition>
          </li>
          <li class="flex2" v-show="kno > 1">
            {{ item.statusName }}
          </li>
          <li v-show="flag">
            <button @click="itemDel(index)" class="itemDel">削除</button>
          </li>
        </ul>
      </div>
      <!--  全选 提交-->
      <div class="checkall">
        <!-- 添加商品 -->
        <div class="quanxuan fl" v-if="kno < 9">
          <!-- 数量 -->
          <div class="number">
            <p>商品数：{{ numTotal }}</p>
          </div>
          <div v-if="flag">
            <input type="checkbox" v-model="checked1" size="medium" @change="commodityAll" />全てを選択
            <!-- <span @click="delOrder">削除</span> -->
            <a href="javascript:;" class="zhuijia">
              追加
              <div class="tianjia">
                <a href="javascript:;" @click="getCartList">買い物かごから</a>
                <a href="javascript:;" style="border-top: 2px solid #eee" @click="addSPK">商品庫から追加</a>
              </div>
            </a>
          </div>
        </div>
        <div class="quanxuan" v-else>
          <!-- 数量 -->
          <div class="number">
            <p>商品数：{{ numTotal }}</p>
          </div>
          <div>
            <input type="checkbox" v-model="checked1" size="medium" @change="commodityAll" />全てを選択
          </div>
        </div>
        <div>
          <!-- 合计 -->
          <div class="heji">
            <p>
              合計金額:
              <strong>{{
                (
                  money +
                  brokerage +
                  optionCost +
                  guoDistribution +
                  (ordno.ta - 0)
                ).toFixed(2)
              }}</strong>
              元
              <span>({{
                Math.round(
                  Rate *
                  (money +
                    brokerage +
                    optionCost +
                    guoDistribution +
                    (ordno.ta - 0))
                )
              }}
                円)</span>
            </p>
            <p class="rate">（1元={{ Rate }}円）</p>
          </div>
          <div v-if="kno == 1">
            <a href="javascript:;" class="tichu" @click="verifySite(1)">注文を提出</a>
            <a href="javascript:;" class="save" @click="verifySite(0)">一時保存</a>
          </div>
          <div v-else>
            <div v-if="flag">
              <a href="javascript:;" class="tichu" @click="verifySite(2)">再提出</a>
              <a href="javascript:;" class="save" @click="newOrder">キャンセル</a>
            </div>
            <div v-else>
              <!-- <router-link :to="{name:'payment',query:{ordno:orderID}}" class="tichu">支払い</router-link> -->
              <a href="javascript:;" class="tichu" @click="payment" v-if="kno == 3">支払い</a>
              <a href="javascript:;" class="save" @click="correction" v-if="kno == 3">注文書修正</a>
              <!-- <a
                href="javascript:;"
                class="tichu"
                v-if="kno == 10"
                @click="addMerchandise"
                >商品庫に入る</a
              > -->
            </div>
          </div>
        </div>
      </div>
      <!-- 实际支付金额 -->
      <!-- <actualMoney :amount_detail="amount_detail" v-if="kno > 3" /> -->
      <!-- 小计，地址，配送方式 -->
      <div class="finally">
        <div class="item">
          <h3>小計：</h3>
          <!-- 小计 -->
          <ul class="cost">
            <li>
              <span>商品金額：</span>
              {{ money.toFixed(2) }}元
            </li>
            <li>
              <span>手数料(15元/点)：</span>
              {{ brokerage.toFixed(2) }}元
            </li>
            <!-- <li>
            <span>オプション手数料：</span>
            {{ optionCost.toFixed(2) }}元
          </li> -->
            <li>
              <span>国内送料：</span>
              {{ guoDistribution }}元
            </li>
            <li>
              <span>その他：</span>
              {{ ordno.ta == null ? 0 : ordno.ta }}元
              <el-popover placement="right" trigger="click" width="300">
                <pre class="text" v-html="ordno.other_cost_remark"></pre>

                <i slot="reference"> 詳細</i>
              </el-popover>
            </li>
          </ul>
        </div>
        <!-- <a href="javascript:;">詳細</a> -->
        <!-- 地址 -->
        <div class="item site">
          <h3>輸入者(Importer)</h3>
          <!-- 輸入者(Importer) -->
          <div class="importer">
            <el-select v-model="address1.remark" placeholder="配送先管理から選択" @change="selectSite($event, 1)" size="medium">
              <el-option v-for="item in aid" :key="item.aid" :label="item.remark" :value="item.aid"></el-option>
            </el-select>

            <div class="importer-box">
              <ul>
                <li>
                  <span> 会社：</span>
                  <input type="text" v-model="address1.company" />
                </li>
                <li>
                  <span> 氏名：</span>

                  <input type="text" v-model="address1.realname" @blur="address1.company || verifySiteNull(address1.realname, 0)" />
                </li>
                <li>
                  <span> 郵便：</span>

                  <input type="text" v-model="address1.zip" @blur="verifySiteNull(address1.zip, 1)" />
                </li>
                <li>
                  <span> 住所：</span>

                  <input type="text" v-model="address1.address" @blur="verifySiteNull(address1.address, 2)" />
                </li>
                <li>
                  <span> 携帯番号：</span>

                  <input type="text" v-model="address1.mobile" @blur="verifySiteNull(address1.mobile, 3)" />
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="site item">
          <h3>配送先</h3>
          <!-- 配送先 -->
          <div class="importer">
            <el-select v-model="address2.remark" placeholder="配送先管理から選択" @change="selectSite($event, 2)" size="medium">
              <el-option v-for="item in hid" :key="item.aid" :label="item.remark" :value="item.aid"></el-option>
            </el-select>

            <div class="importer-box">
              <ul>
                <li>
                  <span> 会社：</span>

                  <input type="text" v-model="address2.company" />
                </li>
                <li>
                  <span> 氏名：</span>

                  <input type="text" v-model="address2.realname" @blur="verifySiteNull(address2.realname, 0)" />
                </li>
                <li>
                  <span> 郵便：</span>

                  <input type="text" v-model="address2.zip" @blur="verifySiteNull(address2.zip, 1)" />
                </li>
                <li>
                  <span> 住所：</span>

                  <input type="text" v-model="address2.address" @blur="verifySiteNull(address2.address, 2)" />
                </li>
                <li>
                  携帯番号：
                  <input type="text" v-model="address2.mobile" @blur="verifySiteNull(address2.mobile, 3)" />
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- 备注 选择发送方式 -->
        <div class="beizhu item">
          <h3>国際運送会社：</h3>
          <div class="top">
            <div class="logistics">

              <el-select v-model="sendOrderList.express" placeholder="配送先管理から選択" size="medium"
                @change="changeExpress($event)">
                <el-option v-for="item in option" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <!-- <p
                v-if="
                  sendOrderList.express == '1' || sendOrderList.express == 'OCS'
                "
              >
                一箱３０KG以内、電池、水は含んだ商品は発送できません。
              </p> -->
              <!-- <p
                v-if="
                  sendOrderList.express == '2' ||
                  sendOrderList.express == '倉庫止め'
                "
              >
                一番安定した航空便。
              </p> -->
              <p v-if="sendOrderList.express == '3'
              ">
                5KG以下の時のみ使用可能。
              </p>
            </div>
          </div>
          <textarea name="reworkmes" cols="45" rows="8" v-model="sendOrderList.remark" style="resize: none"></textarea>
        </div>
      </div>
    </div>
    <!-------------------- 弹框 添加购物车----------------->
    <div class="tankuan">
      <el-dialog :visible.sync="addDialogVisible" width="91%" center>
        <h2>カードから追加</h2>
        <div class="daigou">
          <div class="daigou-title">
            <div class="checkall fl">
              <input type="checkbox" v-model="checked" @change="checkedAll" />
              <span>すべてを選択</span>
            </div>
            <div class="fl">モール</div>
            <div class="fl details">商品詳細</div>
            <div class="fl">単価</div>
            <div class="fl num">数量</div>
            <div class="fl">値段</div>
            <div class="fl caozuo">操作</div>
          </div>
          <div class="table" v-for="(item, index) in lists" :key="index">
            <div class="table-top">
              <input type="checkbox" v-model="item.checked" @change="shopChecked(index, item.checked)"
                style="margin-left: 10px" />
              <span>店铺：{{ item.com }}</span>
              <img src="../../assets/img/1688.png" v-if="item.goods[0].type == 1688" alt />
              <img src="../../assets/img/taobao.png" v-else-if="item.goods[0].type == 'taobao'" alt />
              <img src="../../assets/img/tmall.png" v-else-if="item.goods[0].type == 'tmall'" alt />
            </div>
            <ul>
              <li v-for="(item2, index2) in item.goods" :key="index2">
                <div class="checked-box fl">
                  <input type="checkbox" v-model="item2.checked"
                    @change="commodityChecked(index, index2, item2.checked)" />
                </div>
                <div class="img-box fl" @click="examine(item2.iid, item2.type)" v-if="item2.company != 'rakumart'">
                  <img :src="item2.pic" alt />
                </div>
                <div class="img-box fl" @click="examine(item2.iid, 1)" v-else>
                  <img :src="item2.pic" alt />
                </div>
                <div class="txt-box fl">
                  <h3>{{ item2.title }}</h3>
                  <input type="text" v-model="item2.beikao" placeholder="備考欄"
                    @blur="beikao(item2.beikao, item2.id, item)" class="input" />
                </div>
                <div class="colour-box fl">
                  <p>カラー：{{ item2.color }}</p>
                  <p>サイズ：{{ item2.psize }}</p>
                </div>
                <div class="price-box fl" v-if="item2.company != 'rakumart'">
                  <div v-for="(item3, index3) in item2.priceRanges" :key="index3">
                    <p>￥{{ item3.price }}</p>
                    <span>>={{ item3.begin }}PCS ¥{{ item3.price }}</span>
                  </div>
                </div>
                <div class="price-box fl" v-else>
                  <p style="margin-top: 50px">￥{{ item2.price }}</p>
                </div>
                <div class="num-box fl" v-if="item2.company == 'rakumart'">
                  <el-input-number v-model="item2.num" :min="1" label="描述文字" size="small" @change="
                    changeNum(item2.num, item2, index, index2, item2.id)
                    "></el-input-number>
                </div>
                <div class="num-box fl" v-else>
                  <el-input-number v-model="item2.num" :min="1" label="描述文字" size="small" @change="
                    changeNum(
                      item2.num,
                      item2.priceRanges,
                      index,
                      index2,
                      item2.id
                    )
                    "></el-input-number>
                </div>
                <div class="subtotal fl">
                  ￥{{ item2.priceTotal.toFixed(2) }}
                </div>
                <div class="caozuo fl">
                  <el-button size="mini" @click="delItem(item2.id)">削除</el-button>
                </div>
              </li>
            </ul>
          </div>
          <!-- 结算 -->
          <div class="daigou-title total">
            <p>
              選択中商品
              <em>{{ num }}</em> 点 合計:
              <em>￥{{ total.toFixed(2) }}</em>
            </p>
            <button @click="zhuwen">追加</button>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 添加商品 弹框 -->
    <div class="tankuan SPK">
      <el-dialog :visible.sync="SPaddDialogVisible" width="50%">
        <h2>URL商品追加</h2>
        <div>
          <ol>
            <li class="flex3">URL</li>
            <li>カラー</li>
            <li>サイズ</li>
            <li>数量</li>
            <li>単価（元）</li>
          </ol>
          <ul>
            <li class="flex3"><input type="text" v-model="SPKlists.url" /></li>
            <li><input type="text" v-model="SPKlists.color" /></li>
            <li><input type="text" v-model="SPKlists.psize" /></li>
            <li>
              <input type="text" v-model="SPKlists.num" oninput="this.value=this.value.replace(/[^\d.]/g,'')" @input="
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                if (SPKlists.num < 1) {
                SPKlists.num = 1;
              }
                " />
            </li>
            <li><input type="text" v-model="SPKlists.price" /></li>
          </ul>
          <!-- 结算 -->
          <div class="daigou-title total">
            <button @click="zhuwen2">追加</button>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 余额不足提示 -->
    <el-dialog title="注意" :visible.sync="moneyDialogVisible" width="30%" center>
      <span style="line-height: 30px" v-html="errorContent"></span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="moneyDialogVisible = false">確 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Top from "../../components/head/Top";
import { mapState } from "vuex";
import actualMoney from './components/actualMoney'
import {
  getCartList,
  delItem,
  changeNum,
  beikao,
  newOrder,
  delOrder,
  sendOrder,
  updateOrder,
  addCommodity,
  balanceTotal,
  updateDeliveryFile,
} from "../../api/API/shoppingCart";
import { getCurrentDate } from "../../utlis/utlis";
import { getAddress, addAddress1 } from "../../api/API/site";
export default {
  data() {
    return {
      delivery_file: "", //上传的文件
      errorContent: "",
      shanchuShow: true,
      moneyDialogVisible: false,
      Rate: "", // 汇率
      time: "", //当前时间
      token: localStorage.getItem("token"),
      flag: false, // 判断是预览订单。订单详情
      i: -1,
      address2: {}, // 地址一
      address1: {}, // 地址2
      aid: [], // 地址list1
      hid: [], // 地址list2
      newList: [], //// 预览商品
      //请求参数
      orderList: {
        mod: "inc",
        act: "ordersys",
        str: "newOrder",
        token: localStorage.getItem("token"),
        ids: "",
      },
      checked1: false, // 全选
      isChoose: "", // 类名
      num: 0, // 商品数量
      orderID: "", // 订单号
      ordno: {},
      option: [
        // {
        //   value: "1",
        //   label: "OCS",
        // },
        {
          value: "1",
          label: "倉庫止め",
        },
        {
          value: "3",
          label: "無在庫便",
        },
        {
          value: "10",
          label: "POST便",
        },
      ], // 运输option
      optionList: [], //option选填
      arrId1: [], //获取选项的id
      arrId: [], // 获取商品id
      shopNum: 0, //店铺数
      numTotal: 0, // 总数量
      money: 0, // 总价
      tenshu: 0, // 手续费率
      brokerage: 0, // 手续费
      guoDistribution: 0,
      optionCost: 0, // option 费
      optionNum: 0, // 提取字符串option数量
      // 临时保存 /正式保存参数
      sendOrderList: {
        token: "",
        ordno: "",
        goods: [],
        state: 1,
        remark: "",
        aid: "",
        express: '3',
        hid: "",
      },
      kno: "", // 订单状态
      optionArr: [], // 提取option的数量数组
      amendAdd: 0,
      addDialogVisible: false, // 添加购物车的弹框
      SPaddDialogVisible: false, // 商品库弹框
      //----------------------------添加购物车 -------------------
      checked: false, // 全选
      input: "", // 备注
      price: "",
      lists: [], // 总数据
      SPKlists: {}, // 商品库
      num: 0, // 选中的数量
      total: 0, // 选中的总价
      arr: [], // 选中商品的id
      list: {
        mod: "inc",
        act: "ordersys",
        str: "getCartList",
        token: this.token,
        ignoreIds: "",
      },
      arrList: [], // 追加商品list
      ignoreIds: "", // 已存在id
      amount_detail: { new: {}, old: {} },//实际支付金额
    };
  },
  components: {
    Top,
    actualMoney,
  },
  computed: {
    ...mapState(["exchangeRate"]),
  },
  created() {
    this.balanceTotal();
    this.Rate = this.exchangeRate;
    // 当前时间
    this.time = getCurrentDate();
    // 获取地址
    this.getAddress();
    if (
      this.$route.query.cid != undefined ||
      this.$route.query.ordno != undefined
    ) {
      this.newOrder();
    } else {
      this.shanchuShow = false;
      // 从商品库下单
      if (this.$route.query.type != undefined) {
        //   this.newList.
        let list = JSON.parse(window.name);
        list.data.forEach((item) => {
          this.newList.push(item);
        });
        this.addCommodityList();
        this.commodityMoney();
        this.create();
        let that = this;
        setTimeout(function () {
          that.Rate = that.exchangeRate;
          that.$forceUpdate();
        }, 1000);
      }
      newOrder(this.orderList).then((res) => {
        this.orderID = res.data.ordno;
      });
    }
  },
  methods: {
    //上传文件
    handleAvatarSuccess(file) {
      if (file.code != 0) return this.$message.error(file.msg);

      this.delivery_file = file.data;
      let datas = {
        ordno: this.orderID,
        filePath: file.data,
      };
      updateDeliveryFile(datas);
    },
    // 未充值提示
    balanceTotal() {
      balanceTotal().then((res) => {
        if (res.data.balance <= 0 && res.data.needConfirmBalance == 0) {
          this.moneyDialogVisible = true;
          this.errorContent =
            "現在残高が０円になっております。予めデポジットにご入金をいただければ、買い付けと出荷スピードの向上につながります。よろしくお願いいたします。";
        }
      });
    },
    // 获取地址
    getAddress() {
      var list = {
        mod: "inc",
        act: "ordersys",
        str: "getAddress",
        token: this.token,
      };
      getAddress(list).then((res) => {
        if (res.code != 1) return;
        this.aid = res.data.delivery;
        this.hid = res.data.outlet;
      });
    },
    // 选择地址
    selectSite(e, i) {
      if (i == 1) {
        this.aaid = e;
        this.aid.forEach((item) => {
          if (item.aid == e) {
            this.address1 = item;
          }
        });
      } else if (i == 2) {
        this.hhid = e;
        this.hid.forEach((item) => {
          if (item.aid == e) {
            this.address2 = item;
          }
        });
      }
    },
    // 验证地址不能为空
    verifySiteNull(data, i) {
      if (data == undefined || data == "") {
        if (i == 0) {
          this.$message.error("氏名をご記入ください。");
        } else if (i == 1) {
          this.$message.error("郵便をご記入ください。");
        } else if (i == 2) {
          this.$message.error("住所をご記入ください。");
        } else if (i == 3) {
          this.$message.error("携帯番号をご記入ください。");
        }
      }
    },
    // 验证地址 完成提交 i= 0 临时保存，i=1 提出，i=2 修改提交
    verifySite(i) {
      var list = {
        mod: "inc",
        act: "ordersys",
        str: "addAddress1",
        token: this.token,
        company: this.address1.company,
        realname: this.address1.realname,
        zip: this.address1.zip,
        address: this.address1.address,
        mobile: this.address1.mobile,
        def1: 1,
        def2: 0,
        status: 0,
      };
     
      // 直送（無在庫便 / POST便）提出：进口商公司/氏名二选一，收件人氏名必填
      if (
        (this.sendOrderList.express == "3" ||
          this.sendOrderList.express == "無在庫便" ||
          this.sendOrderList.express == "POST便" ||
          this.sendOrderList.express == 10) &&
        i != 0
      ) {
        if (
          (this.address1.company == undefined || this.address1.company == "") &&
          (this.address1.realname == undefined || this.address1.realname == "")
        ) {
          return this.$message.error("会社または氏名をご記入ください。");
        }
        if (
          this.address2.realname == undefined ||
          this.address2.realname == ""
        ) {
          return this.$message.error("氏名をご記入ください。");
        }
      }
      addAddress1(list).then((res) => {
        if (res.code != 1) {
          if (
            (this.sendOrderList.express == "3" ||
              this.sendOrderList.express == "無在庫便" || this.sendOrderList.express == 'POST便' || this.sendOrderList.express == 10) &&
            i != 0
          ) {
            return this.$message.error("輸入者をご記入ください。");
          }
        }
        this.sendOrderList.aid = res.data.aid;
        list.company = this.address2.company;
        list.realname = this.address2.realname;
        list.zip = this.address2.zip;
        list.address = this.address2.address;
        list.mobile = this.address2.mobile;
        list.filePath = this.delivery_file
        this.def1 = 0;
        this.def2 = 1;
        addAddress1(list).then((res) => {
          if (res.code != 1) {
            if (
              (this.sendOrderList.express == "3" ||
                this.sendOrderList.express == "無在庫便" || this.sendOrderList.express == 'POST便' || this.sendOrderList.express == 10) &&
              i != 0
            ) {
              return this.$message.error("配送先をご記入ください。");
            }
          }
          this.sendOrderList.hid = res.data.aid;
          //   修改提交
          if (i == 2) {
            this.updateOrder();
          } else {
            if (i == 0) {
              // 临时保存
              this.sendOrderList.state = 0;
            } else {
              // 提交
              this.sendOrderList.state = 1;
            }
            this.submitOrder();
          }
        });
      });
    },
    // 商品详情
    newOrder() {
      this.orderList.token = this.token;
      if (this.$route.query.ordno != undefined) {
        this.orderList.str = "getOrderDetail";
        this.orderList.ordno = this.$route.query.ordno;
      } else if (this.$route.query.cid != undefined) {
        this.orderList.ids = this.$route.query.cid;
        //  state 1 标识 从商品库来的
        if (this.$route.query.state == 1) {
          this.orderList = {
            mod: "inc",
            act: "ordersys",
            str: "commodityOrderPreview",
            token: this.token,
            ids: this.$route.query.cid,
          };
        }
      }
      newOrder(this.orderList).then((res) => {
        if (res.code != 1) return this.$message.error(res.msg);
        if (this.$route.query.cid || this.$route.query.ids) {
          // 商品预览
          this.newList = res.data.goods;
          this.orderID = res.data.ordno;
          this.tenshu = res.data.tenshu;
          this.ordno = res.data.ordno;
        } else {
          this.amount_detail = res.data.amount_detail
          // 商品详情
          this.newList = res.data.goods;
          this.orderID = res.data.ordno.ordno;
          this.tenshu = res.data.ordno.tenshu;
          this.shopNum = res.data.goods.length;
          this.kno = res.data.ordno.kno;
          this.ordno = res.data.ordno;
          this.delivery_file = res.data.ordno.delivery_file;
          this.sendOrderList.remark = res.data.ordno.remark;

          if (res.data.address1 != "") {
            this.address1 = res.data.address1;
            this.aaid = res.data.address1.aid;
          } else {
            this.address1.remark = "";
          }
          if (res.data.address2) {
            this.address2 = res.data.address2;
            this.hhid = res.data.address1.hid;
          } else {
            this.address2.remark = "";
          }
          this.sendOrderList.express = res.data.ordno.express;
          this.Rate = res.data.ordno.huiru;

          this.kno == 1 ? (this.flag = true) : (this.flag = false);
        }
        this.jineTotal();
        this.commodityMoney();
        // this.newOrderList = this.sendOrderList;
        console.log(this.newList);
      });
    },
    // 自行捋逻辑，我也懵逼了
    jineTotal() {
      this.sendOrderList.token = this.token;
      this.sendOrderList.ordno = this.orderID;
      this.sendOrderList.goods = [];
      this.create();
      this.newList.forEach((item, index) => {
        // 获取添加排除id
        this.arrId.push(item.id);
        // 修改呈现的数据
        if (this.amendAdd != 1) {
          if (this.$route.query.ordno != undefined) {
            this.sendOrderList.goods[index].delete = 0;
            if (item.poption != undefined) {
              this.optionArr[index] = item.poption.split(",");
              this.optionArr[index].forEach((item1, index1) => {
                this.optionList[index].forEach((item2) => {
                  if (item1.substr(0, 1) == item2.title.substr(0, 1)) {
                    item2.checked = true;
                    item2.num = item1.replace(/[^0-9]/gi, "");
                    this.optionsMoney();
                  }
                });
              });
            }
          }
        }
      });
    },
    // 创建提交数据
    create() {
      this.numTotal = 0;
      this.newList.forEach((item, index) => {
        // 创建提交参数
        this.sendOrderList.goods[index] = {
          company: item.company,
          id: item.id,
          iid: item.iid,
          mi_id: item.mi_id,
          type: item.type,
          pic: item.pic,
          num: item.num,
          color: item.color,
          price: item.price,
          psize: item.psize,
          bei: item.bei ? item.bei : item.beikao,
          title: item.title,
          poption: item.poption,
          fba: item.fba,
          checked: false,
          checked_2: false,
        };

        // 创建option
        this.optionList[index] = [
          {
            checked: false,
            title: "①FBA(1元/点)",
            num: item.num,
          },
          {
            checked: false,
            title: "②有料検品(商品代金6%)",
            num: item.num,
            disabled: true,
          },
          {
            checked: false,
            title: "③OPP袋取り替え(0.5元)",
            num: item.num,
          },
          {
            checked: false,
            title: "④織ネーム取り外し(1.5元/点))",
            num: item.num,
          },
          {
            checked: false,
            title: "⑤織ネーム縫い付け(1元/点)",
            num: item.num,
          },
          {
            checked: false,
            title: "⑥下げ札取り付け(1元/点)",
            num: item.num,
          },
          {
            checked: false,
            title: "⑦下げ札取り外し(1元/点)",
            num: item.num,
          },
          {
            checked: false,
            title: "⑧セット(1元/セット)",
            num: item.num,
          },
          {
            checked: false,
            title: "⑨写真",
            num: item.num,
          },
        ];
        // 商品总条数
        this.numTotal += item.num - 0;
      });
    },
    // 点击options
    options(i) {
      if (this.newList[i].checked_2 == false) {
        this.newList.forEach((item) => {
          item.checked_2 = false;
        });
      }
      this.newList[i].checked_2 = !this.newList[i].checked_2;
    },
    // 计算商品金额
    commodityMoney() {
      this.money = 0;
      this.numTotal = 0;
      this.guoDistribution = 0;
      this.arrId = [];

      if (this.kno < 3) {
        this.newList.forEach((item, index) => {
          this.arrId.push(item.id);
          this.numTotal += item.num - 0;
          if (item.gnsong != undefined) {
            this.guoDistribution += item.gnsong - 0;
          }
          if (this.$route.query.ordno != undefined) {
            this.money += item.price * item.num;
          } else {
            if (item.company == "rakumart") {
              this.money += item.price * item.num;
            } else {
              if (item.priceRanges == undefined) {
                this.money += item.price * item.num;
              } else {
                if (item.priceRanges.length == 1) {
                  this.money += item.priceRanges[0].price * item.num;
                } else if (item.priceRanges.length == 2) {
                  if (
                    item.num >= item.priceRanges[0].begin &&
                    item.num < item.priceRanges[1].begin
                  ) {
                    this.money += item.priceRanges[0].price * item.num;
                  } else if (item.num >= item.priceRanges[1].begin) {
                    this.money += item.priceRanges[1].price * item.num;
                  }
                } else if (item.priceRanges.length == 3) {
                  if (
                    item.num >= item.priceRanges[0].begin &&
                    item.num < item.priceRanges[1].begin
                  ) {
                    this.money += item.priceRanges[0].price * item.num;
                  } else if (
                    item.num >= item.priceRanges[1].begin &&
                    item.num < item.priceRanges[2].begin
                  ) {
                    this.money += item.priceRanges[1].price * item.num;
                  } else if (item.num >= item.priceRanges[2].begin) {
                    this.money += item.priceRanges[2].price * item.num;
                  }
                }
              }
            }
          }
        });
      } else {
        this.newList.forEach((item, index) => {
          this.arrId.push(item.id);
          this.numTotal += item.zaiko - 0;
          if (item.gnsong != undefined) {
            this.guoDistribution += item.gnsong - 0;
          }
          if (this.$route.query.ordno != undefined) {
            this.money += item.price * item.zaiko;
          } else {
            if (item.company == "rakumart") {
              this.money += item.price * item.zaiko;
            } else {
              if (item.priceRanges == undefined) {
                this.money += item.price * item.zaiko;
              } else {
                if (item.priceRanges.length == 1) {
                  this.money += item.priceRanges[0].price * item.zaiko;
                } else if (item.priceRanges.length == 2) {
                  if (item.zaiko < item.priceRanges[0].begin) {
                    this.money += item.priceRanges[0].price * item.zaiko;
                  } else if (item.zaiko >= item.priceRanges[1].begin) {
                    this.money += item.priceRanges[1].price * item.zaiko;
                  }
                } else if (item.priceRanges.length == 3) {
                  if (item.zaiko < item.priceRanges[0].begin) {
                    this.money += item.priceRanges[0].price * item.zaiko;
                  } else if (
                    item.zaiko >= item.priceRanges[1].begin &&
                    item.zaiko < item.priceRanges[2].begin
                  ) {
                    this.money += item.priceRanges[1].price * item.zaiko;
                  } else if (item.zaiko >= item.priceRanges[2].begin) {
                    this.money += item.priceRanges[2].price * item.zaiko;
                  }
                }
              }
            }
          }
        });
      }

      this.brokerage = 15 * this.numTotal;
    },
    // 修改option数量
    optionsItem(index, num, index1) {
      this.amendAdd = 0;
      if (this.newList[index].num - 0 < num) {
        this.$message.error("数量不能大于件数");
        this.optionList[index][index1].num = this.newList[index].num;
      } else {
        this.optionList[index][index1].num = num;
      }
      this.optionsMoney();
    },
    // 计算option费用 自行捋逻辑，我也懵逼了
    optionsMoney() {
      this.optionCost = 0;
      for (let i = 0; i < this.optionList.length; i++) {
        this.sendOrderList.goods[i].poption = "";
        for (let j = 0; j < this.optionList[i].length; j++) {
          if (this.optionList[i][j].checked == true) {
            if (this.optionList[i][j].num == null) {
              return this.$message.error("请输入数量");
            }
            if (/^①|⑤|⑥|⑦|⑧/.test(this.optionList[i][j].title)) {
              this.sendOrderList.goods[i].poption +=
                this.optionList[i][j].title.substring(0, 1) +
                `(${this.optionList[i][j].num}個),`;
              this.optionCost += this.optionList[i][j].num - 0;
            } else if (/^②/.test(this.optionList[i][j].title)) {
              this.sendOrderList.goods[i].poption +=
                this.optionList[i][j].title.substring(0, 1) + `,`;
              if (this.$route.query.ordno == undefined) {
                if (this.newList[i].priceRanges == null) {
                  this.optionCost += Number(
                    this.newList[i].num * this.newList[i].price * 0.06
                  );
                } else {
                  if (this.$route.query.state == 1) {
                    this.optionCost += Number(
                      this.newList[i].num * this.beikao[i].price * 0.06
                    );
                  } else {
                    if (this.newList[i].priceRanges.length == 1) {
                      this.optionCost += Number(
                        this.newList[i].priceRanges[0].price *
                        this.newList[i].num *
                        0.06
                      );
                    } else if (this.newList[i].priceRanges.length == 2) {
                      if (
                        this.newList[i].num <
                        this.newList[i].priceRanges[0].begin
                      ) {
                        this.optionCost += Number(
                          this.newList[i].priceRanges[0].price *
                          this.newList[i].num *
                          0.06
                        );
                      } else if (
                        this.newList[i].num >= this.newList[i].priceRanges[1]
                      ) {
                        this.optionCost += Number(
                          this.newList[i].priceRanges[1].price *
                          this.newList[i].num *
                          0.06
                        );
                      }
                    } else if (this.newList[i].priceRanges.length == 3) {
                      if (
                        this.newList[i].num <
                        this.newList[i].priceRanges[0].begin
                      ) {
                        this.optionCost += Number(
                          this.newList[i].priceRanges[0].price *
                          this.newList[i].num *
                          0.06
                        );
                      } else if (
                        this.newList[i].num >= this.newList[i].priceRanges[1] &&
                        this.newList[i].num < this.newList[i].priceRanges[2]
                      ) {
                        this.optionCost += Number(
                          this.newList[i].priceRanges[1].price *
                          this.newList[i].num *
                          0.06
                        );
                      } else if (
                        this.newList[i].num > this.newList[i].priceRanges[2]
                      ) {
                        this.optionCost += Number(
                          this.newList[i].priceRanges[1].price *
                          this.newList[2].num *
                          0.06
                        );
                      }
                    }
                  }
                }
              } else {
                this.optionCost += Number(
                  this.newList[i].num * this.newList[i].price * 0.06
                );
              }
            } else if (/^④/.test(this.optionList[i][j].title)) {
              this.sendOrderList.goods[i].poption +=
                this.optionList[i][j].title.substring(0, 1) +
                `(${this.optionList[i][j].num}個),`;
              this.optionCost += this.optionList[i][j].num * 1.5;
            } else if (/^⑥/.test(this.optionList[i][j].title)) {
              this.sendOrderList.goods[i].poption +=
                this.optionList[i][j].title.substring(0, 1) +
                `(${this.optionList[i][j].num}個),`;
              if (this.optionList[i][j].num <= 3) {
                this.optionCost += Number(this.optionList[i][j].num * 0.5);
              } else if (this.optionList[i][j].num > 3) {
                this.optionCost +=
                  Math.ceil(this.optionList[i][j].num / 3) * 0.5 - 0;
              }
            } else if (/^③/.test(this.optionList[i][j].title)) {
              this.sendOrderList.goods[i].poption +=
                this.optionList[i][j].title.substring(0, 1) +
                `(${this.optionList[i][j].num}個),`;
              this.optionCost += Number(this.optionList[i][j].num * 0.5);
            } else if (/^⑨/.test(this.optionList[i][j].title)) {
              this.sendOrderList.goods[i].poption +=
                this.optionList[i][j].title.substring(0, 1) +
                `(${this.optionList[i][j].num}個),`;

              if (this.optionList[i][j].num == 1) {
                this.optionCost += 12;
              } else if (
                this.optionList[i][j].num >= 2 &&
                this.optionList[i][j].num <= 5
              ) {
                this.optionCost += 40;
              } else if (
                this.optionList[i][j].num >= 6 &&
                this.optionList[i][j].num <= 8
              ) {
                this.optionCost += 60;
              } else if (this.optionList[i][j].num > 8) {
                this.optionCost += 60;
                this.optionCost += (this.optionList[i][j].num - 8) * 7;
              }
            }
          }
        }
        this.sendOrderList.goods[i].poption = this.sendOrderList.goods[
          i
        ].poption.substring(0, this.sendOrderList.goods[i].poption.length - 1);
      }
    },
    // 修改新数量
    changeNewNum(num, index) {
      this.newList[index].num = num;
      this.sendOrderList.goods[index].num = num;
      this.optionCost = 0;
      // 修改optionList 数量
      this.optionList[index].forEach((item) => {
        item.num = num;
      });
      this.optionsMoney();
      this.commodityMoney();
      this.newOrderList = this.sendOrderList;
    },
    // 商品选择
    commoditySelect() {
      this.arrId1 = [];
      let flag = this.newList.every((item) => item.checked == true);
      this.newList.forEach((item) => {
        if (item.checked == true) {
          this.arrId1.push(item.id);
        }
      });

      flag == true ? (this.checked1 = true) : (this.checked1 = false);
    },
    // 商品全选
    commodityAll() {
      this.arrId1 = [];

      if (this.checked1 == true) {
        this.newList.forEach((item) => {
          item.checked = true;
          this.arrId1.push(item.id);
        });
      } else if (this.checked1 == false) {
        this.newList.forEach((item) => {
          item.checked = false;
        });
      }
      this.commoditySelect();
    },
    // 单个删除
    itemDel(j) {
      this.newList.splice(j, 1);
      this.optionList.splice(j, 1);
      this.sendOrderList.goods.splice(j, 1);
      this.commodityMoney();
      this.optionsMoney();
    },
    // 删除订单
    delOrder() {
      for (let i = 0; i < this.arrId1.length; i++) {
        for (var j = 0; j < this.newList.length; j++) {
          if (this.arrId1[i] == this.newList[j].id) {
            this.newList.splice(j, 1);
            this.optionList.splice(j, 1);
            this.sendOrderList.goods.splice(j, 1);
          }
        }
      }

      //   this.create();
      this.commodityMoney();
      this.optionsMoney();
    },
    // 物流方式
    changeExpress(e) {
      console.log(e);
    },
    // 修改备注
    modify(i, index, data) {
      //   i;
      this.i = -1;
      if (i == 1) {
        this.sendOrderList.goods[index].fba = data;
      } else {
        this.sendOrderList.goods[index].bei = data;
      }
    },
    // 支付修改订单
    correction() {
      this.flag = true;
      this.kno = 2;
    },
    // 提交保存
    submitOrder() {

      this.sendOrderList.token = this.token;
      this.sendOrderList.ordno = this.orderID;
      this.sendOrderList.filePath = this.delivery_file,
        console.log(this.sendOrderList);
      sendOrder(this.sendOrderList).then((res) => {
        if (res.code != 1) {
          this.moneyDialogVisible = true;
          this.errorContent = res.msg;
          return false;
        }
        let datas = {
          ordno: this.orderID,
          filePath: this.delivery_file,
        };
        updateDeliveryFile(datas);
        this.$router.push("/user/proceedOrder");
      });
    },
    // 修改订单提交
    updateOrder() {
      delete this.sendOrderList.state;
      this.sendOrderList.filePath = this.delivery_file,
        //   this.sendOrderList.aid = this.ordno.aid;
        //   this.sendOrderList.hid = this.ordno.hid;

        //   console.log(this.sendOrderList);
        updateOrder(this.sendOrderList).then((res) => {
          if (res.code != 1) {
            this.moneyDialogVisible = true;
            this.errorContent = res.msg;
            return false;
          }
          this.$router.push("/user/proceedOrder");
        });
    },
    // 支付
    payment() {
      this.$router.push({ path: "/payment", query: { ordno: this.orderID } });
    },
    // 添加商品库
    addMerchandise() {
      let list = { commodity: [] };
      if (this.arrId1 == false)
        return this.$message.error("商品を選択してください");
      this.newList.forEach((item, index) => {
        if (item.checked == true) {
          list.commodity[index] = {
            manageId: "",
            pic: item.pic,
            url: "",
            color: item.color,
            size: item.psize,
            price: item.price,
            poptions: item.poption,
            fba: item.fba,
            title: item.title,
            remark: item.bei,
            iid: item.iid,
            type: item.type,
            company: item.company,
          };
        }
      });
      //   list.commodity = commodity;
      console.log(list.commodity);
      addCommodity(this.token, list).then((res) => {
        if (res.code != 1) return this.$message.error(res.msg);
        this.$message.success(res.msg);
      });
    },
    // --------------------------------------------------------------
    // 请求购物车数据
    getCartList() {
      this.amendAdd = 1;
      this.list.token = this.token;

      if (this.arrId.every((item) => item == "")) {
        this.list.ignoreIds = "";
      } else {
        this.list.ignoreIds = this.arrId.join(",");
      }

      getCartList(this.list).then((res) => {
        if (res.code != 1) return;
        this.lists = res.data;
      });
      this.addDialogVisible = true;
    },
    // 删除购物车
    delItem(id) {
      var list = {
        mod: "inc",
        act: "ordersys",
        str: "delCart",
        token: this.token,
        ids: id,
      };
      this.$confirm("こちらの商品削除されますか？?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "キャンセル",
        type: "warning",
        center: true,
      })
        .then(() => {
          delItem(list).then((res) => {
            if (res.code != 1) return this.$message.error("削除失敗");
            this.getCartList();
            this.total = 0;
            this.num = 0;
            // this.getCart();
            this.$message({
              type: "success",
              message: "削除成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "削除キャンセル",
          });
        });
    },
    // 备注修改
    beikao(beizhu, id) {
      var list = {
        mod: "inc",
        act: "ordersys",
        str: "editCartRemark",
        token: this.token,
        id: id,
        beikao: beizhu,
      };
      beikao(list).then((res) => {
        if (res.code != 1) return;
        this.$message.success("保存成功");
      });
    },
    // 修改数量
    changeNum(num, item, index, index2, id) {
      var list = {
        mod: "inc",
        act: "ordersys",
        str: "upCartNum",
        token: this.token,
        id: id,
        num: Math.floor(num),
      };
      changeNum(list).then((res) => {
        if (item.company == "rakumart") {
          return (this.lists[index].goods[index2].priceTotal =
            num * item.price);
        }
        if (res.code != 1) return;
        if (item.length == 1) {
          this.lists[index].goods[index2].priceTotal = num * item[0].price;
        } else if (item.length == 2) {
          if (num < item[1].begin) {
            this.lists[index].goods[index2].priceTotal = num * item[0].price;
          } else if (num >= item[1].begin) {
            this.lists[index].goods[index2].priceTotal = num * item[1].price;
          }
        } else if (item.length == 3) {
          if (num < item[1].begin) {
            this.lists[index].goods[index2].priceTotal = num * item[0].price;
          } else if (num >= item[1].begin && num < item[2].begin) {
            this.lists[index].goods[index2].priceTotal = num * item[1].price;
          } else if (num >= item[2].begin) {
            this.lists[index].goods[index2].priceTotal = num * item[2].price;
          }
        }
        this.commodityTotal();
      });
    },
    // 店铺全选
    shopChecked(index, checked) {
      var shop = this.lists[index].goods;
      if (checked == true) {
        for (var i = 0; i < shop.length; i++) {
          shop[i].checked = true;
        }
        this.commodityTotal();
      } else if (checked == false) {
        for (var i = 0; i < shop.length; i++) {
          shop[i].checked = false;
        }
        this.commodityTotal();
      }
      this.isCheckedAll();
    },
    // 商品单选
    commodityChecked(index, index2) {
      var shop = this.lists[index].goods;
      var flag = shop.every((item, index) => item.checked == true);
      if (flag == true) {
        this.lists[index].checked = true;
      } else {
        this.lists[index].checked = false;
      }
      this.commodityTotal();
      this.isCheckedAll();
    },
    // 全选商店
    checkedAll() {
      if (!this.lists.length) return;
      if (this.checked == true) {
        for (let i = 0; i < this.lists.length; i++) {
          this.lists[i].checked = true;
          this.shopChecked(i, this.lists[i].checked);
        }
      } else if (this.checked == false) {
        for (let i = 0; i < this.lists.length; i++) {
          this.lists[i].checked = false;
          this.shopChecked(i, this.lists[i].checked);
        }
      }
      this.isCheckedAll();
    },
    // 是否全选中
    isCheckedAll() {
      var flag = this.lists.every((item, index) => item.checked == true);
      if (flag == true) {
        this.checked = true;
      } else {
        this.checked = false;
      }
    },
    // 选中商品数量总数、总价
    commodityTotal() {
      this.total = 0;
      this.num = 0;
      this.arr = [];
      this.arrList = [];
      for (var i = 0; i < this.lists.length; i++) {
        for (var j = 0; j < this.lists[i].goods.length; j++) {
          if (this.lists[i].goods[j].checked == true) {
            this.total += this.lists[i].goods[j].priceTotal;
            this.num += this.lists[i].goods[j].num;
            this.arr.push(this.lists[i].goods[j].id);
            this.arrList.push(this.lists[i].goods[j]);
          }
        }
      }
      console.log(this.arrList);
    },
    // 查看商品详情
    examine(id, type) {
      // 自营标识 1
      if (type == 1) {
        let routeUrl = this.$router.resolve({
          path: "/details?id=" + id,
        });
        window.open(routeUrl.href, "_blank");
      } else {
        // 1688
        let routeUrl = this.$router.resolve({
          path: "/details1688?iid=" + id + "&type=" + type,
        });
        window.open(routeUrl.href, "_blank");
      }
    },
    // 批量删除
    delAll() {
      var arr = this.arr.join(",");
      this.delItem(arr);
    },
    zhuwen() {
      this.numTotal = 0;
      if (this.arr == false) {
        this.$message.error("商品を選択してください");
      } else {
        this.addDialogVisible = false;
        this.arrList.forEach((item) => {
          item.bei = item.beikao;
          delete item.id;
        });
        this.newList = [...this.newList, ...this.arrList];
        this.newList.forEach((item) => {
          item.checked = false;
        });
        this.addCommodityList();
        this.commodityMoney();
        this.arrList = [];
      }
    },
    // 追加商品数据
    addCommodityList() {
      this.arrList.forEach((item) => {
        this.sendOrderList.goods.push({
          company: item.company,
          id: item.id,
          iid: item.iid,
          mi_id: item.mi_id,
          type: item.type,
          pic: item.pic,
          num: item.num,
          color: item.color,
          price: item.price,
          psize: item.psize,
          bei: item.bei,
          title: item.title,
          poption: item.poption,
          fba: item.fba,
        });
        this.optionList.push([
          {
            checked: false,
            title: "①FBA(1元/点)",
            num: item.num,
          },
          {
            checked: false,
            title: "②有料検品(商品代金6%)",
            num: item.num,
            disabled: true,
          },
          {
            checked: false,
            title: "③OPP袋取り替え(0.5/点)",
            num: item.num,
          },
          {
            checked: false,
            title: "④織ネーム(2元/点)",
            num: item.num,
          },
          {
            checked: false,
            title: "⑤下げ札(1元/点)",
            num: item.num,
          },
          {
            checked: false,
            title: "⑥セット組(0.5元/組)",
            num: item.num,
          },
          {
            checked: false,
            title: "⑦印刷物封入(１元/面）",
            num: item.num,
          },
          {
            checked: false,
            title: "⑧印刷物封入( 2 元/両面）",
            num: item.num,
          },
          {
            checked: false,
            title: "⑨緩衝材梱包（１元/点）",
            num: item.num,
          },
          {
            checked: false,
            title: "⑩写真",
            num: item.num,
          },
        ]);
      });
      console.log(this.sendOrderList.goods);
    },
    // --------------------商品库 --------------
    // addSPK() {
    //   this.SPaddDialogVisible = true;
    //   let list = {
    //     mod: "inc",
    //     act: "ordersys",
    //     str: "getCommodityList",
    //     token: this.token,
    //   };
    //   getCartList(list).then((res) => {
    //     if (res.code != 1) return;
    //     this.SPKlists = res.data;
    //   });
    // },
    addSPK() {
      this.SPaddDialogVisible = true;
      this.SPKlists = {
        bei: "",
        checked: "",
        checked_2: "",
        color: "",
        company: "",
        fba: "",
        gnsong: "",
        id: "",
        iid: "",
        kno: "",
        num: "",
        pic: "",
        poption: "",
        price: "",
        psize: "",
        rownum: "",
        sbei: "",
        title: "",
        type: "",
        url: "",
        zaiko: "",
      };
    },
    // 添加商品库总数
    totalNum() {
      this.num = 0;
      this.arrList = [];
      this.SPKlists.forEach((item) => {
        if (item.checked == true) {
          this.num++;
          this.arrList.push(item);
        }
      });
    },
    // 商品库里添加
    zhuwen2() {
      if (this.SPKlists.url == "") {
        return this.$message.error("urlをご記入ください");
      }
      if (this.SPKlists.price == "") {
        return this.$message.error("単価をご記入ください");
      }
      if (this.SPKlists.num == "") {
        return this.$message.error("数量をご記入ください");
      }
      var reg1 = /[?|&]id=(\d{10,15})/;
      var reg2 = /detail.1688.com\/offer\/([0-9]+)/;
      var iidArr = [];
      let regtaobao = RegExp(/taobao/);
      let regtmall = RegExp(/tmall/);
      let reg1688 = RegExp(/1688/);
      if (regtaobao.test(this.SPKlists.url)) {
        this.SPKlists.type = "taobao";

        iidArr = this.SPKlists.url.match(reg1);
      } else if (regtmall.test(this.SPKlists.url)) {
        this.SPKlists.type = "tmall";

        iidArr = this.SPKlists.url.match(reg1);
      } else if (reg1688.test(this.SPKlists.url)) {
        this.SPKlists.type = "1688";

        iidArr = this.SPKlists.url.match(reg2);
      }
      this.SPKlists.iid = iidArr[1];
      this.newList.push(this.SPKlists);
      this.SPaddDialogVisible = false;
      this.addCommodityList();
      this.commodityMoney();
      this.create();
    },
    GetQueryString(name) {
      var reg = new RegExp("(^|&)" + id + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
  },
};
</script>
<style lang='scss' scoped>
@import "../../css/zhuwen.scss";
</style>
